












































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  getCurrentInstance,
  ComponentInternalInstance,
  Ref,
  watch,
} from '@vue/composition-api';
import {
  CaretRightIcon,
  ErrorCircleFilledIcon,
  ChevronRightIcon,
  EllipsisIcon,
  StopIcon,
  FolderIcon,
} from 'tdesign-icons-vue';
import { DialogInstance } from 'tdesign-vue';
import DropFile from '@/renderer/components/DropFile.vue';
import CoSyncConflictDrawer from '@/renderer/views/desktop/FileManagement/FileSync/components/COSyncConflictDrawer/index.vue';
import CoSyncOperateDrawer from '@/renderer/views/desktop/FileManagement/FileSync/components/CoSyncOperateDrawer.vue';
import CoSyncListItemStatusVue from '@/renderer/views/desktop/FileManagement/FileSync/components/CoSyncListItemStatus.vue';
import SelectFolder from '@/renderer/views/desktop/FileManagement/FileSync/components/SelectFolder/SelectFolder.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import useCoSyncConflictHandler from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncConflictHandler';
import useCoSyncSourceHandler from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncSourceHandler';
import { SyncTableItemData } from '@/renderer/views/desktop/FileManagement/FileSync/composition/FileSyncUIDefine';
import useSelectFolderHandler from '@/renderer/views/desktop/FileManagement/FileSync/composition/SelectFolderHandler';
import { CoSyncCenterEvent } from '@/renderer/scripts/CoSync/SyncCenter/CoSyncCenterEvent';
import { SyncTaskUIStatus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';
import useSyncTaskControlHandler, {
  canStart,
  canStop,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/SyncTaskControlHandler';
import { CoSyncStatus, CoSynStatusInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncEvent';
import { drawerHandler } from '@/renderer/scripts/composition/drawerHandler';
import ipc from '@/renderer/scripts/utils/ipc';
import { IpcEvents } from '@/ipc-events';
import { coSync } from '@/renderer/scripts/CoSync/coSync';
import { syncCenterEventBus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenterEventBus';
import {
  ClickAreaInCoSyncPage,
  CoSyncReporter,
  ShowConfigDialogSource,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';
import { CoSyncInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import tips from '@/renderer/scripts/utils/tips';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  components: {
    CaretRightIcon,
    ErrorCircleFilledIcon,
    ChevronRightIcon,
    EllipsisIcon,
    StopIcon,
    FolderIcon,
    CoSyncListItemStatusVue,
    SelectFolder,
    DropFile,
    CoSyncConflictDrawer,
    CoSyncOperateDrawer,
    Menu,
    MenuItem,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    const { methods: coSyncMethods } = coSync;
    coSyncMethods.immediatelyLoadSyncCenter();

    const {
      shouldShowFoldSelector,
      foldSelectorConfig,
      foldSelectorLocalPath,
      isFoldSelectorCreateBaseLocal,
      methods: selectFolderMethods,
    } = useSelectFolderHandler();

    const {
      tableColumns,
      tableData,
      selectedRows,
      selectedRowKeys,
      sortConfig,
      hoverRowTaskId,
      methods: sourceMthods,
    } = useCoSyncSourceHandler();

    const { methods: controlMethods } = useSyncTaskControlHandler();

    const {
      shouldShowConflictDrawer,
      conflictTaskCount,
      conflictListData,
      methods: conflictMethods,
    } = useCoSyncConflictHandler();

    const { drawerHandlerMethods } = drawerHandler();

    const isWithSyncDir = ref<boolean | null>(null);
    const isInitLoading = computed(() => isWithSyncDir.value === null);

    const loadingSeq = ref<number | null>(null);
    const isLoading = computed(() => loadingSeq.value !== null);

    const selectedTaskCount = computed(() => selectedRowKeys.value.length);
    const isNotTaskSelected = computed(() => selectedTaskCount.value === 0);
    const isSingleTaskSelected = computed(() => selectedTaskCount.value === 1);

    const shouldShowbrowseLocalForSelectedTask = computed(() => isSingleTaskSelected.value);
    const shouldShowSettingForSelectedTask = computed(() => isSingleTaskSelected.value);
    const shouldShowOenSyncListForSelectedTask = computed(() => isSingleTaskSelected.value);
    const shouldShowDeleteForSelectedTask = computed(() => !isNotTaskSelected.value);

    const isActionDisabled = computed(() => isLoading.value);

    const shouldShowConflictTips = computed(() => {
      return conflictTaskCount.value > 0;
    });

    const conflictTipsWording = computed(() =>
      i18n_t('存在{slot1}个同步文件夹冲突，需处理后继续同步', { slot1: conflictTaskCount.value }),
    );

    // 选中的任务是否可以开始
    const isSelectedtaskStartable = computed(() => methods.isStartable(selectedRows.value));

    // 选中的任务是否可以停止
    const isSelectedtaskStopable = computed(() => methods.isStopable(selectedRows.value));

    // 执行状态抽屉相关
    const shouldShowOperateStatusDrawer = ref(false);
    const operateStatusDrawerTaskId: Ref<number> = ref(-1);
    const operateStatusDrawerTab: Ref<number> = ref(-1);

    // 右键菜单
    const menuShouldShowByMouse = ref(false);
    const shouldShowRightClickMenu = computed(() => selectedTaskCount.value > 0);
    const rightClickMenuItems = computed(() =>
      [
        isSelectedtaskStartable.value
          ? {
              value: 'start',
              wording: i18n_t('开始'),
            }
          : null,
        isSelectedtaskStopable.value
          ? {
              value: 'stop',
              wording: i18n_t('停止'),
            }
          : null,

        {
          value: 'delete',
          wording: i18n_t('删除'),
        },
        shouldShowbrowseLocalForSelectedTask.value
          ? {
              value: 'browseLocal',
              wording: i18n_t('浏览本地位置'),
            }
          : null,
        shouldShowSettingForSelectedTask.value
          ? {
              value: 'setting',
              wording: i18n_t('设置'),
            }
          : null,
        shouldShowOenSyncListForSelectedTask.value
          ? {
              value: 'openSyncList',
              wording: i18n_t('同步列表'),
            }
          : null,
      ]
        .filter(it => it)
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .map(it => it!),
    );

    const methods = {
      async handleActionForOneTask(
        action: 'start' | 'stop' | 'delete' | 'setting' | 'browseLocal' | 'openSyncList',
        row: SyncTableItemData,
      ) {
        switch (action) {
          case 'start':
            controlMethods.startTasks([row.coSyncInfo]);
            break;

          case 'stop':
            controlMethods.stopTasks([row.coSyncInfo]);
            break;

          case 'delete':
            {
              const dialog: DialogInstance = CustomDialog.confirm({
                theme: 'warning',
                header: i18n_t('确定要删除已选中的同步任务吗？'),
                body: i18n_t('删除后不会影响已同步文件'),
                width: '400px',
                async onConfirm() {
                  dialog.update?.({
                    confirmBtn: {
                      content: i18n_t('删除中'),
                      theme: 'primary',
                      loading: true,
                    },
                  });

                  const rowsAfterRemoved = selectedRows.value.filter(it => it.taskId !== row.taskId);
                  // TODO(renlyhuang): 这里通过选中状态停止drawer是异步的，会因为异步出现删除后还去查询历史
                  // 需要修改为drawer的通信方式，使之支持同步修改，而不是watch
                  sourceMthods.rehandleSelectChange(rowsAfterRemoved);
                  await controlMethods.deleteTasks([row.coSyncInfo]);
                  if (dialog?.hide) {
                    dialog.hide();
                  }
                },
              });
            }

            break;

          case 'setting':
            methods.showTaskConfig(row, ShowConfigDialogSource.SettingButtonInItem);
            break;

          case 'browseLocal':
            {
              const isOpen = await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
                event: 'openPath',
                params: { path: row.localPath },
              });
              if (!isOpen) {
                tips.error(i18n_t('本地文件已被移动、删除或重命名，无法打开'));
              }
            }

            break;

          case 'openSyncList':
            methods.handleClickItemStatus({ coSyncInfo: row.coSyncInfo, statusInfo: row.source.statusInfo }, true);
            break;
        }
      },

      async handleActionForSelectedTask(
        action: 'start' | 'stop' | 'delete' | 'setting' | 'browseLocal' | 'openSyncList',
      ) {
        switch (action) {
          case 'start': {
            const selectedCoSyncInfoList = selectedRows.value.map(it => it.coSyncInfo);
            if (selectedCoSyncInfoList.length === 0) {
              console.error(`apply command:start when not task selected`);
              return;
            }
            return controlMethods.startTasks(selectedCoSyncInfoList);
          }

          case 'stop': {
            const selectedCoSyncInfoList = selectedRows.value.map(it => it.coSyncInfo);
            if (selectedCoSyncInfoList.length === 0) {
              console.error(`apply command:stop when not task selected`);
              return;
            }

            return controlMethods.stopTasks(selectedCoSyncInfoList);
          }

          case 'delete':
            {
              const selectedCoSyncInfoList = selectedRows.value.map(it => it.coSyncInfo);
              if (selectedCoSyncInfoList.length === 0) {
                console.error(`apply command:delete when not task selected`);
                return;
              }

              const dialog: DialogInstance = CustomDialog.confirm({
                theme: 'warning',
                header: i18n_t('确定要删除已选中的同步任务吗？'),
                body: i18n_t('删除后不会影响已同步文件'),
                width: '400px',
                async onConfirm() {
                  dialog.update?.({
                    confirmBtn: {
                      content: i18n_t('删除中'),
                      theme: 'primary',
                      loading: true,
                    },
                  });

                  sourceMthods.rehandleSelectChange([]);
                  await controlMethods.deleteTasks(selectedCoSyncInfoList);

                  if (dialog?.hide) {
                    dialog.hide();
                  }
                },
              });
            }

            break;

          case 'setting':
            {
              const selectedRowList = selectedRows.value;
              if (selectedRowList.length !== 1) {
                console.error(`call show config when ${selectedRowList.length} task selected`);
                return;
              }

              methods.showTaskConfig(selectedRowList[0], ShowConfigDialogSource.SettingButtonInHeader);
            }
            break;

          case 'browseLocal':
            {
              const selectedRowList = selectedRows.value;
              if (selectedRowList.length !== 1) {
                console.error(`call browseLocal when ${selectedRowList.length} task selected`);
                return;
              }
              methods.handleActionForOneTask(action, selectedRowList[0]);
            }
            break;

          case 'openSyncList':
            {
              const selectedRowList = selectedRows.value;
              if (selectedRowList.length !== 1) {
                console.error(`call openSyncList when ${selectedRowList.length} task selected`);
                return;
              }
              methods.handleActionForOneTask(action, selectedRowList[0]);
            }
            break;
        }
      },

      handleClickBtnInList(
        action: 'start' | 'stop' | 'delete' | 'setting' | 'browseLocal' | 'openSyncList',
        row: SyncTableItemData,
      ) {
        CoSyncReporter.getInstance().reportClickBtnInCoSyncPageListItem(action);
        methods.handleActionForOneTask(action, row);
      },

      shouldShowActionInList(action: string, row: SyncTableItemData): boolean {
        if (action === 'start') {
          return methods.isStartable([row]) && row.taskId === hoverRowTaskId.value;
        }

        if (action === 'stop') {
          return methods.isStopable([row]) && row.taskId === hoverRowTaskId.value;
        }

        if (action === 'browseLocal') {
          return row.taskId === hoverRowTaskId.value;
        }

        if (action === 'more') {
          return row.taskId === hoverRowTaskId.value;
        }

        return false;
      },

      handleClickItemInMore(action: 'setting' | 'delete' | 'openSyncList', row: SyncTableItemData) {
        methods.handleClickBtnInList(action, row);
        sourceMthods.handleDropdownClickOutside();
      },

      showTaskConfig(row: SyncTableItemData, from: ShowConfigDialogSource) {
        selectFolderMethods.showCertainConfigDialog(row.coSyncInfo, from);
      },

      // 任务是否可以开始
      isStartable(rows: SyncTableItemData[]): boolean {
        return rows.filter(it => canStart(it.source)).length > 0;
      },

      // 任务是否可以停止
      isStopable(rows: SyncTableItemData[]): boolean {
        if (rows.length === 0) return false;

        return rows.filter(it => canStop(it.source)).length > 0;
      },

      handleClickCreateBtnInHeader(data: any) {
        const action = data.value as 'createSyncLocal' | 'createSyncremote';
        methods.handleClickBtnInHeader(action);
      },

      handleClickConflictTips() {
        CoSyncReporter.getInstance().reportClickInCoSyncPage(ClickAreaInCoSyncPage.ConflictTips);
        methods.showConflictDrawer();
      },

      handleClickBtnInHeader(action: 'start' | 'stop' | 'delete' | 'setting' | 'createSyncLocal' | 'createSyncremote') {
        CoSyncReporter.getInstance().reportClickBtnInCoSyncPageListHeader(action);
        switch (action) {
          case 'start':
          case 'stop':
          case 'delete':
          case 'setting':
            methods.handleActionForSelectedTask(action);
            break;

          case 'createSyncLocal':
            CoSyncReporter.getInstance().reportClickInCoSyncPage(ClickAreaInCoSyncPage.CreateLocalButtonInHeader);
            selectFolderMethods.showCreateLocalDialog(ShowConfigDialogSource.LocalButtonInListHeader);
            break;

          case 'createSyncremote':
            CoSyncReporter.getInstance().reportClickInCoSyncPage(ClickAreaInCoSyncPage.CreateRemoteButtonInHeader);
            selectFolderMethods.showCreateRemoteDialog(ShowConfigDialogSource.RemoteButtonInListHeader);
            break;
        }
      },

      handleClickBtnInEmptyPage(action: 'createSyncLocal' | 'createSyncremote') {
        switch (action) {
          case 'createSyncLocal':
            CoSyncReporter.getInstance().reportClickInCoSyncPage(ClickAreaInCoSyncPage.CreateLocalButtonInEmptyPage);
            selectFolderMethods.showCreateLocalDialog(ShowConfigDialogSource.LocalButtonInEmptyPage);
            break;

          case 'createSyncremote':
            CoSyncReporter.getInstance().reportClickInCoSyncPage(ClickAreaInCoSyncPage.CreateRemoteButtonInEmptyPage);
            selectFolderMethods.showCreateRemoteDialog(ShowConfigDialogSource.RemoteButtonInEmptyPage);
            break;
        }
      },

      handleClickItemStatus(
        clickContext: { coSyncInfo: CoSyncInfo; statusInfo: CoSynStatusInfo },
        forceShowList = false,
      ) {
        CoSyncReporter.getInstance().reportClickInCoSyncPage(ClickAreaInCoSyncPage.StatusAreaInItem);

        switch (clickContext.statusInfo.status) {
          case CoSyncStatus.STATUS_ERROR:
          case CoSyncStatus.STATUS_CONFLICT: {
            if (!forceShowList) {
              if (clickContext.statusInfo.status === CoSyncStatus.STATUS_ERROR) {
                // do nothing
                return;
              }
              if (clickContext.statusInfo.status === CoSyncStatus.STATUS_CONFLICT) {
                methods.showConflictDrawer();
                return;
              }

              return;
            }
            // fallthrough
          }
          case CoSyncStatus.STATUS_STOP:
          case CoSyncStatus.STATUS_IDLE:
          case CoSyncStatus.STATUS_WAIT_FOR_RUNNING:
          case CoSyncStatus.STATUS_RUNNING:
          case CoSyncStatus.STATUS_SUCCESS:

          case CoSyncStatus.STATUS_WARN: {
            let drawerTabs = 1;
            if ([CoSyncStatus.STATUS_ERROR, CoSyncStatus.STATUS_WARN].includes(clickContext.statusInfo.status)) {
              drawerTabs = 2;
            }

            conflictMethods.closeConflictDialog();
            operateStatusDrawerTaskId.value = clickContext.coSyncInfo.localSyncId;
            operateStatusDrawerTab.value = drawerTabs;
            shouldShowOperateStatusDrawer.value = true;
            break;
          }

          default: {
            const _exhaustiveCheck: never = clickContext.statusInfo.status;
            return _exhaustiveCheck;
          }
        }
      },

      setDrawer(taskStatus: SyncTableItemData | undefined) {
        if (!taskStatus) {
          vm.$store.commit(DrawerEvents.SET_TOTAL, tableData.value.length);
          const emptyScope: Drawer.EmptyScope = {
            title: '',
            componentName: 'EmptyDetail',
          };
          drawerHandlerMethods.setDrawers([emptyScope]);
          return;
        }

        const coSyncRecordScope: Drawer.CoSyncRecordScope<SyncTaskUIStatus> = {
          title: i18n_t('同步记录'),
          subtitle: i18n_t('仅展示最近30天操作记录'),
          componentName: 'CoSyncRecordDrawer',
          params: taskStatus?.source,
        };
        drawerHandlerMethods.setDrawers([coSyncRecordScope]);
      },

      rehandleTableSelectChange(value: number[], param: any) {
        const selectedDataList = param.selectedRowData as SyncTableItemData[];

        sourceMthods.rehandleSelectChange(selectedDataList);
      },

      showConflictDrawer() {
        shouldShowOperateStatusDrawer.value = false; // drawer互斥
        conflictMethods.showConflictDialog();
      },

      rightClickCallback(event: any): boolean {
        const { path, currentTarget } = event;
        if (currentTarget && currentTarget.className && !currentTarget.className.includes('sync-list-row')) {
          return false;
        }
        // firefox和safari用composedPath
        const parent = path || (event.composedPath && event.composedPath());
        return parent.find(
          (item: HTMLElement) =>
            item.tagName && item.tagName.toLowerCase() === 'tr' && !item.className.includes('disable'),
        );
      },

      menuShowCallback(shouldShowMenu: boolean) {
        menuShouldShowByMouse.value = shouldShowMenu;
      },

      handleRightMenuClick(action: 'start' | 'stop' | 'delete' | 'browseLocal' | 'setting' | 'openSyncList') {
        CoSyncReporter.getInstance().reportClickBtnInCoSyncPageRightMenu(action);
        methods.handleActionForSelectedTask(action);
      },
      handleVisibleChange(visible: boolean) {
        if (!visible) {
          sourceMthods.handleDropdownClickOutside();
        }
      },
    };

    const onTaskStatusMapChange = (taskStatusMap?: Map<number, SyncTaskUIStatus>) => {
      if (!taskStatusMap) {
        isWithSyncDir.value = null;
        return;
      }

      CoSyncReporter.getInstance().reportCoSyncPageShowEnd(taskStatusMap.size, isInitLoading.value);
      isWithSyncDir.value = taskStatusMap.size > 0;
    };

    const handleRouterQuery = () => {
      const from = vm.$route.query?.from;
      if (from) {
        switch (from) {
          case 'conflictNotification':
            methods.showConflictDrawer();
            break;
          default:
        }
      }
    };

    onMounted(() => {
      CoSyncReporter.getInstance().reportCoSyncPageShowBegin();
      onTaskStatusMapChange(coSync.centerData().syncTaskStatusMap);
      syncCenterEventBus.on(CoSyncCenterEvent.onTaskStatusMapChange, onTaskStatusMapChange);
      handleRouterQuery();

      coSync.center().queryUpdateConfigList();
    });
    onUnmounted(() => {
      syncCenterEventBus.off(CoSyncCenterEvent.onTaskStatusMapChange, onTaskStatusMapChange);
    });

    let drawerRowTaskId: number | undefined = undefined;

    watch(
      () => selectedRows.value,
      rows => {
        if (rows.length === 1) {
          // 只有选中1个才展示drawer
          const row = rows[0];
          if (row.taskId !== drawerRowTaskId) {
            // 不是相同的同步盘才需要改drawer
            drawerRowTaskId = row.taskId;
            methods.setDrawer(row);
          }
        } else {
          drawerRowTaskId = undefined;
          methods.setDrawer(undefined);
        }
      },
      { immediate: true },
    );

    return {
      isWithSyncDir,
      isInitLoading,

      tableColumns,
      tableData,
      selectedRowKeys,
      sortConfig,
      hoverRowTaskId,

      shouldShowStartInHeader: isSelectedtaskStartable,
      shouldShowStopInHeader: isSelectedtaskStopable,
      shouldShowSettingInHeader: shouldShowSettingForSelectedTask,
      shouldShowDeleteInHeader: shouldShowDeleteForSelectedTask,
      isActionDisabled,
      shouldShowConflictTips,
      conflictTipsWording,
      shouldShowConflictDrawer,
      conflictListData,

      shouldShowFoldSelector,
      foldSelectorConfig,
      foldSelectorLocalPath,
      isFoldSelectorCreateBaseLocal,

      shouldShowOperateStatusDrawer,
      operateStatusDrawerTaskId,
      operateStatusDrawerTab,

      shouldShowRightClickMenu,
      rightClickMenuItems,

      ...methods,
      ...conflictMethods,
      ...sourceMthods,
      ...selectFolderMethods,

      remotePathTipsStyle: (trigger: HTMLElement) => ({ 'word-break': 'break-all' }),
    };
  },
});
